export default __webpack_public_path__ + "static/IBMPlexSans-Italic-5838098bb6df72433f24458f0a17d8a1.woff2";